import Axios from 'axios'
import { toggleDefaultData } from './toggle'

const order = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BACKEND_URL

    return AxiosInstance
  },
  getAllOrders(
    offset,
    limit,
    status,
    states,
    q,
    idFile,
    orders,
    docDelivered,
    findTypeOrderResultFilter,
    patientRoutine) {
    return this.axios().post('/order/filter-orders', {
      limit: limit,
      offset: offset * limit,
      status: status,
      states: states,
      query: q,
      idFile: idFile,
      orderList: orders,
      docDelivered: docDelivered,
      findTypeOrderResultFilter: findTypeOrderResultFilter,
      patientRoutine,
    })
  },
  getOrderDetails(id) {
    return this.axios().get('/order/' + id)
  },
  deleteOrder(orderId) {
    return this.axios().delete('/order/' + orderId)
  },
  deleteSelectedOrders(orders) {
    return this.axios().post('/order/deleteAll', orders)
  },
  inactiveVoucher() {
    return this.axios().get('/order/voucher-check')
  },
  performTransfer(selectedItems) {
    const toggleData = toggleDefaultData()
    const headers = { asyncBatch: toggleData?.feature.nonSegregatedBatchList }

    return this.axios().put('/order/transmit', selectedItems, { headers })
  },
  createOs(order) {
    return this.axios().post('/order', order)
  },
  getOs(id) {
    return this.axios().get('/order/' + id + '/edit')
  },
  editOS(order, id) {
    return this.axios().put('/order/' + id, order)
  },
  deleteExamOrder(orderId, examId) {
    return this.axios().delete('/order/' + orderId + '/exam/' + examId)
  },
  countOsTransmitting() {
    return this.axios().get('/order/count-transmitting')
  },
  countTotalOrders(offset, limit, status, states, q, orders) {
    return this.axios().post('/order/count-total-orders', {
      limit: limit,
      offset: offset * limit,
      status: status,
      states: states,
      query: q,
      orderList: orders,
    })
  },
  insertNewExamAfterTransfered(order, id) {
    const toggleData = toggleDefaultData()

    return this.axios().put('/order/maintenance/' + id, order.exams, {
      params: {
        asyncBatch: toggleData?.feature.nonSegregatedBatchList,
      },
    })
  },
  deleteNewExamAfterTransfered(idOrder, idExam) {
    return this.axios().delete('/order/maintenance/' + idOrder + '/' + idExam)
  },
  getDocPendentOrders(filterData) {
    return this.axios().post('/order/filter-documents', filterData)
  },
  getCountFilterDocuments() {
    return this.axios().get('/order/count-filter-documents')
  },
  getCollectDate(orderId) {
    return this.axios().get('/order-api/v2/v1/orders/collect-date', {
      baseURL: process.env.BASE_URL_API,
      params: {
        orderId: orderId,
      },
    })
  },
}

export default order
